import { atom } from "jotai"

export const discoveryModalOpenAtom = atom<boolean>(false)
